import {
  enumWorkOrderSortOption,
  WorkOrderSortOption,
  WorkOrderStatus,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { workOrdersQueryAtom } from '../_graphql/queryWorkOrders';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedStatus = atomFromQueryString.string('status');
export const $selectedProcessingType = atomFromQueryString.string('type');
export const $selectedFacility = atomFromQueryString.string('f');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<WorkOrderSortOption[]>([
  enumWorkOrderSortOption.CreatedAtDesc,
]);

export const $remoteWorkOrders = workOrdersQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const selectedStatus = get($selectedStatus);
  const selectedProcessingType = get($selectedProcessingType);
  const selectedFacility = get($selectedFacility);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  return {
    variables: {
      searchTerm: searchTerm || undefined,
      status:
        selectedStatus && selectedStatus !== 'all'
          ? [selectedStatus as WorkOrderStatus]
          : undefined,
      processingTypeIds:
        selectedProcessingType && selectedProcessingType !== 'all'
          ? [selectedProcessingType]
          : undefined,
      facilityIds:
        selectedFacility && selectedFacility !== 'all'
          ? [selectedFacility]
          : undefined,
      limit,
      offset,
      sorting,
    },
  };
});
